import { render } from "./sti-sc-update-reverse-scan.vue?vue&type=template&id=2c941de8&scoped=true&ts=true"
import script from "./sti-sc-update-reverse-scan.vue?vue&type=script&lang=ts"
export * from "./sti-sc-update-reverse-scan.vue?vue&type=script&lang=ts"

import "./sti-sc-update-reverse-scan.vue?vue&type=style&index=0&id=2c941de8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c941de8"]])

export default __exports__